import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import LoadingNavBar from '../../components/navbar/LoadingNavBar';
import Footer from '../../components/footer/Footer';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const About = () => {
  const { t } = useTranslation();
  
  const colors = {
    background: "#ffffff",
    primary: "#102a43",
    secondary: "#39ace7",
    textPrimary: "#212529",
    textSecondary: "#495057",
  };

  return (
    <>
      <LoadingNavBar showLoginButton={true} />
      <Box
        sx={{
          background: colors.background,
          color: colors.textPrimary,
          minHeight: '100vh',
          py: 15,
          px: { xs: 3, md: 6 },
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: colors.primary, textAlign: 'center' }}>
            {t(StringKeys.ABOUT_TITLE)}
          </Typography>
          <Typography variant="subtitle1" gutterBottom sx={{ textAlign: 'center', color: colors.textSecondary }}>
            {t(StringKeys.ABOUT_SUBTITLE)}
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Our Story */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.ABOUT_STORY_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.ABOUT_STORY_CONTENT)}
          </Typography>

          {/* What We Offer */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.ABOUT_OFFER_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('comprehensive_solutions')}:</strong> {t(StringKeys.ABOUT_OFFER_COMPREHENSIVE)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('ai_powered_tools')}:</strong> {t(StringKeys.ABOUT_OFFER_AI)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('community_engagement')}:</strong> {t(StringKeys.ABOUT_OFFER_COMMUNITY)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('user_friendly_interface')}:</strong> {t(StringKeys.ABOUT_OFFER_INTERFACE)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('affordable_pricing')}:</strong> {t(StringKeys.ABOUT_OFFER_PRICING)}
          </Typography>

          {/* Our Vision */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.ABOUT_VISION_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.ABOUT_VISION_CONTENT)}
          </Typography>

          {/* Why Choose Us */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.ABOUT_WHY_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('tailored_for_small_businesses')}:</strong> {t(StringKeys.ABOUT_WHY_TAILORED)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('innovative_technology')}:</strong> {t(StringKeys.ABOUT_WHY_TECHNOLOGY)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('exceptional_support')}:</strong> {t(StringKeys.ABOUT_WHY_SUPPORT)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('continuous_improvement')}:</strong> {t(StringKeys.ABOUT_WHY_IMPROVEMENT)}
          </Typography>
          <Typography variant="body1" paragraph>
            - <strong>{t('low_overhead_high_value')}:</strong> {t(StringKeys.ABOUT_WHY_VALUE)}
          </Typography>

          {/* Join Our Growing Community */}
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: colors.primary, mt: 4 }}>
            {t(StringKeys.ABOUT_COMMUNITY_SECTION)}
          </Typography>
          <Typography variant="body1" paragraph>
            {t(StringKeys.ABOUT_COMMUNITY_CONTENT_1)}
          </Typography>

          <Typography variant="body1" paragraph>
            {t(StringKeys.ABOUT_COMMUNITY_CONTENT_2)}
          </Typography>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default About;
